import {useLocation, useNavigate} from 'react-router-dom';
import { useEffect, useState, useImperativeHandle, forwardRef } from 'react';
import GlobalVar from './GlobalVar';



const FiltroEOrdenacoes  = forwardRef(({ativaResp,showStyle, stateInfo, dispachInfo},ref)=>{

    const [usuario, setUsuario] = useState({nome: 'Usuario'});  // ObjetoUsuario 
    const navigate = useNavigate();

    const [showLateralFiltroEOrdenacao, setShowLateralFiltroEOrdenacao] = useState('inicial')
    const [filtrarState, setFiltrarState] = useState('Filtrar')


    const location = useLocation().pathname;

    useImperativeHandle(ref, (value) => ({
        // methods connected to `ref`
        setShowLateralFiltroEOrdenacao: (value) => {
            setShowLateralFiltroEOrdenacao(value)
        }
      }))

    useEffect(() => {
        if (showStyle) {
          // Importa dinamicamente quando necessário
            import('../../assets/css/filtroEOrdenacoes.css');
        }
      }, [showStyle]);

    return <>
    
            <div className={`filtroEOrdenacaoBarraLateral  
            ${showLateralFiltroEOrdenacao === 'inicial' ? 'filtroEOrdenacaoBarraLateralInicial' : showLateralFiltroEOrdenacao ? "mostraFiltroEOrdenacaoLateral" : "escondeFiltroEOrdenacaoLateral"}`}>
        

                <div className="topBtns">
                  <div className='menuCloseBtn' onClick={()=>setShowLateralFiltroEOrdenacao(false)}>Fechar</div>
                    <div className="filtroOuOrdenaBtn">

                      <div className={`filtroBtn filtrar ${filtrarState == 'Filtrar' ? '' : 'escolhido'}`} onClick={()=> setFiltrarState('Filtrar')}>
                        <div className="img"></div>
                        <div className="text">Filtrar</div>
                      </div>

                    </div>

                </div>
                

                <div className="filtroBtns">
                  <div className="filtrosList">
                      <div className="limpaCamposBtn"></div>
                      <div className="buscaPecas"></div>
                      <div>Revistas e Códigos</div>
                      <select
                          className="custom-select"
                          value={stateInfo.revistaSelecionada}
                          onChange={(e)=>dispachInfo({type: 'revistaSelecionada', value: e.target.value})}
                      >
                          {stateInfo.revistas ? <option value={stateInfo.revistas[0].rev_num_rev}>{stateInfo.revistas[0].rev_nom.trim()}</option>
                          : <></>}
                          {stateInfo.revistas ? stateInfo.revistas.map((revista) => (
                          <option key={revista.rev_num_rev} value={revista.rev_num_rev}>
                              {revista.rev_nom.trim()}
                          </option>
                          )) : <></>}
                      </select>
                      <div>Categorias</div>
                      <select
                          className="custom-select"
                          value={stateInfo.categoriaSelecionada}
                          onChange={(e)=>dispachInfo({type: 'categoriaSelecionada', value: e.target.value})}
                      >
                          {stateInfo.produtos ? <option value={""}>Todas Categorias</option>
                          : <></>}
                          {stateInfo.produtos ? stateInfo.produtos?.filter((item, index, self) =>
                            index === self.findIndex(p => p.descbasica === item.descbasica)
                          ).map((categoria) => {
                            // console.log(stateInfo.produtos)
                          return <option key={categoria.descbasica} value={categoria.descbasica}>
                              {categoria.descbasica.trim()}
                          </option>
                      }) : <></>}
                      </select>
                    </div>

                </div>

                <div className="bottomData">

                </div>

            </div>
        </>
})

export default FiltroEOrdenacoes;
  